import { LineChart, Loader2, Pen, Trash, User2, UserIcon } from "lucide-react"
import { User } from "models/user"
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { useUser } from "stores/useUser";
import { useTranslation } from "react-i18next";
import { MSAvatar } from "components/MSAvatar";
import { useEffect, useState } from "react";
import graph from "services/graph";
import { MSUser } from "models/msUser";
import { useGroupStore } from "stores/useGroup";

interface UserListProps {
    user: User;
    onEdit: (user: User) => void;
    onRemove: (user: User) => void;
}
export function UserList({user, onEdit, onRemove}: UserListProps) {
    const { t } = useTranslation()
    const loggedUser = useUser((state) => state.user);
    const group = useGroupStore((state) => state.group);
    const navigate = useNavigate();
    const [msUser, setMsUser] = useState<MSUser | null>(null);

    useEffect(() => {
        if (user.microsoftId)
            graph.get(`/users/${user.microsoftId}`)
                .then(res => setMsUser(res.data))
    }, []);

    return <tr key={user.id} className="hover:bg-zinc-100 group">
      <td className="p-3 align-middle">
        <span className="flex gap-2 items-center">
          <MSAvatar 
            microsoftId={user.microsoftId} 
            subtitle={user.roles.map(r => t("userRole." + r.name)).join(", ")}
            msUser={msUser} 
            showName/>
        </span>
      </td>
      <td className="p-3 align-middle">
        <div className="flex flex-col">
          <span className="text-xs text-zinc-400">{t("users.listAccesses")}</span>
          {user.interactions?.length} {t("users.listAccessesNumber")}
        </div>
      </td>
      <td className="p-3 align-middle">
        <div className="flex flex-col">
          <span className="text-xs text-zinc-400">{t("users.listEmail")}</span>
          <span className="lowercase">{msUser ? msUser.mail : "-"}</span>
        </div>
      </td>
      <td className="p-3 align-middle">
        <div className="flex flex-col">
          {msUser?.mobilePhone && <span className="text-xs text-zinc-400">{t("users.listPhone")}</span>}
          {msUser && msUser.mobilePhone}
        </div>
      </td>
      <td className="p-3 align-middle">
        <div className="flex flex-col">
          <span className="text-xs text-zinc-400">{t("users.listRegistration")}</span>
          {dayjs(user.createdAt).format(t("time.date"))}
        </div>
      </td>
      <td className="p-3 align-middle">{user.crm}</td>
      <td className="p-3 align-middle text-right">
        <div className="invisible group-hover:visible">
          {loggedUser?.id != user.id && user.interactions.length === 0 && <button
            onClick={(_) => onRemove(user)}
            className="p-2 rounded text-zinc-800 hover:bg-red-200 hover:text-red-500"
          >
            <Trash size={20} />
          </button>}
          <button
            onClick={(_) => onEdit(user)}
            className="p-2 rounded hover:bg-zinc-200 text-zinc-800"
          >
            <Pen size={20} />
          </button>
          <button
            onClick={(_) =>
              navigate(`/grupos/${group?.id}/usuarios/${user.id}`)
            }
            className="p-2 rounded hover:bg-zinc-200 text-zinc-800"
          >
            <LineChart size={20} />
          </button>
        </div>
      </td>
    </tr>
}